import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-medicalc",
  "use": "icon-medicalc-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-medicalc\">\r\n<path d=\"M17.5845 10.7368L21.7223 8.33428L18.4299 2.63936L14.2922 5.0419V3.9741V0.236816H7.70743V3.9741V5.0419L3.56972 2.63936L0.277344 8.33428L4.45955 10.7368L3.52522 11.2707L0.277344 13.1394L3.56972 18.8343L6.8176 16.9656L7.70743 16.4317V21.2368H14.2922V16.4317L15.2265 16.9656L18.4299 18.8343L21.7223 13.1394L18.4744 11.2707L17.5845 10.7368Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol